export const VIEWS_SUCCESS = 'VIEWS_SUCCESS'
export const VIEWS_ERROR = 'VIEWS_ERROR'
export const VIEWS_REQUEST = 'VIEWS_REQUEST'
export const VIEWS_ADD = 'VIEWS_ADD'
export const VIEWS_MARK = 'VIEWS_MARK'
export const VIEWS_GET = 'VIEWS_GET'
